import { lazy, Suspense } from "react";
import { FormattedMessage } from "react-intl";
import styles from "./styles.module.scss";
import { TENGE_LABEL } from "@/common/constants/common";
import {
  GESV_RATE_MAX,
  GESV_RATE_MIN,
  GRACE_PERIOD_DAYS,
  LOAN_AMOUNT_MAX_VALUE,
} from "@/common/constants/loan";
import { formatAmount } from "@/common/utils/formatNumber";
import { Typography } from "@/shared/ui/Typography";
import { BRAND_COLOR, LIGHT_COLOR } from "@/styles/colorsJS";

const CalculatorWidget = lazy(
  () =>
    import(
      /* webpackChunkName: "calculator-widget", webpackPrefetch: true */ "@/widgets/CalculatorWidget"
    ),
);

export const BannerMobile = () => {
  return (
    <section className={styles.section}>
      <img
        className={styles.bgImage}
        src="/static/images/summer-bg-mobile.webp"
        alt="background image"
      />
      <div className={styles.content}>
        <div className={styles.topBlock}>
          <div className={styles.headerBlock}>
            <div className={styles.headerBackground} />
            <div className={styles.headerContent}>
              <Typography as="h1" type="h1" align="center">
                <FormattedMessage defaultMessage="Микрокредит онлайн" />
              </Typography>
              <Typography as="h2" type="h1" align="center">
                <FormattedMessage
                  defaultMessage="на карту до {amount}"
                  values={{
                    amount: (
                      <Typography type="h1" align="center" color={BRAND_COLOR}>
                        {formatAmount(LOAN_AMOUNT_MAX_VALUE)} {TENGE_LABEL}
                      </Typography>
                    ),
                  }}
                />
              </Typography>
            </div>
          </div>
          <div className={styles.bullet}>
            <Typography type="title" align="center" color={LIGHT_COLOR}>
              <FormattedMessage
                defaultMessage="Первые {period} дней под 0%"
                values={{ period: GRACE_PERIOD_DAYS }}
              />
            </Typography>
            <Typography type="title" align="center" color={LIGHT_COLOR}>
              <FormattedMessage
                defaultMessage="с 8-го дня ГЭСВ от {rateMin} до {rateMax}"
                values={{
                  rateMin: GESV_RATE_MIN,
                  rateMax: GESV_RATE_MAX,
                }}
              />
            </Typography>
          </div>
        </div>
        <div className={styles.imageHolder}>
          <img
            className={styles.image}
            src="/static/images/summer-girl-mobile.webp"
            alt="neocode girl image"
          />
        </div>
        <div className={styles.bottomBlock}>
          <Suspense fallback={null}>
            <CalculatorWidget />
          </Suspense>
        </div>
      </div>
    </section>
  );
};
